import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getLastTopics } from "@store/action/smartend/FilterAction";

const GallerySection = ({ t }) => {
  const store = useSelector((state) => state.FilterReducer);
  const dispatch = useDispatch();
  const path = "Photos";
  const params2 = { number: 3 };
  const LastTopics = store.LastTopics;
  useEffect(() => {
    dispatch(getLastTopics(path, params2));
  }, [path]);
  const renderRecentPostTopics = () => {
    if (LastTopics.length) {
      return LastTopics.map((item, i) => {
        return (
          <li className="verti-img" key={i}>
            <img src={item.photo_file && item.photo_file} alt="suggest-1" />
          </li>
        );
      });
    }
  };
  return (
    <section className="section gallery-part">
      <div className="container__">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-heading">
              <h2>{t("Gallery")}</h2>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="gallery-content">
              <ul className="gallery-list">
                {renderRecentPostTopics()}
                {/* <li className="verti-img">
                  <img src={gallery1} alt="gallery-1" />
                </li>
                <li className="hori-img">
                  <img src={gallery2} alt="gallery-2" />
                </li>
                <li className="big-img">
                  <img src={gallery3} alt="gallery-3" />
                </li>
                <li>
                  <img src={gallery4} alt="gallery-4" />
                </li>
                <li>
                  <img src={gallery5} alt="gallery-5" />
                </li>
                <li>
                  <img src={gallery2} alt="gallery-6" />
                </li>
                <li>
                  <img src={gallery1} alt="gallery-7" />
                </li> */}
              </ul>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="gallery-btn">
              <Link className="btn btn-outline" to="/Gallery/Photos/topics">
                <i className="fa fa-eye me-1"></i>
                <span>{t("show more")}</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
